import { Grid } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import PropTypes from "prop-types";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { FoldersApi } from "../../../api/folders/folders";
import FolderSettingsMenu from "../../../components/Cards/ItemsView/FolderSettingsMenu";
import CustomButton from "../../../components/CustomButton/CustomButton";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import AppContext from "../../../data/AppContext";
import PageSectionHeader from "../../../layouts/Main/components/Page/PageSectionHeader";
import ItemsContentContainer from "./ItemsContentContainer";

import analytics from "../../../utils/analytics";

/**
 * This container is responsible for fetching the folder details needed for subsiquent items fetching.
 * It also currently sets up the components needed for the page section header when viewing items
 */
export default function ItemsContainer(props) {
	const appContext = useContext(AppContext);
	const isEditor = appContext.user.isEditor;
	const { folderId } = props;
	const [isLoading, setIsLoading] = useState(true);
	const [folderDetails, setFolderDetails] = useState({
		name: "",
		description: "",
		correlationId: "",
	});

	const onCreateItemClicked = () => {
		analytics.logEvent(analytics.eventTypes.FOLDERS.CREATE_ITEM_CLICKED, {
			folder: {
				id: folderDetails.folderId,
				name: folderDetails.name
			}});
	};

	useEffect(() => {
		fetchData();
		document.getElementById("content").scrollTop = 0;
	}, [folderId]);

	const fetchData = async () => {
		setIsLoading(true);
		const folderDetailsResp = await FoldersApi.getFolderDetails(folderId);

		setFolderDetails({
			name: folderDetailsResp.data.name,
			description: folderDetailsResp.data.description,
			correlationId: folderDetailsResp.data.correlationId,
			audience: folderDetailsResp.data.audience,
			defaultBrandingSetId: folderDetailsResp.data.defaultBrandingSetId,
			brandingSets: folderDetailsResp.data.brandingSets,
			folderId: folderId
		});

		setIsLoading(false);
	};

	const PrimaryActions = () => (
		isEditor && (
			<CustomButton
				startIcon={<AddIcon />}
				color="success"
				variant="contained"
				href={`#!/search?contextId=${folderDetails.correlationId}`}
				onClick={onCreateItemClicked}
			>
				Create Item
			</CustomButton>
		)
	);

	const SecondaryActions = props => (
		<Grid container spacing={4}>
			<Grid item>
				<FolderSettingsMenu folderDetails={folderDetails} migrateParentState={setFolderDetails} />
			</Grid>
		</Grid>
	);

	return isLoading ? <LoadingSpinner /> :
		(
			<Fragment>
				<PageSectionHeader
					name={folderDetails.name}
					description={folderDetails.description}
					primaryActions={() => <PrimaryActions />}
					secondaryActions={() => <SecondaryActions {...props} />}
				/>
				<ItemsContentContainer
					folderId={folderId}
					folderDetails={folderDetails}
				/>
			</Fragment>
		);
}

ItemsContainer.propTypes = {
	folderId: PropTypes.number
};
